<template>
  <v-dialog persistent v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="#043554" v-bind="attrs" v-on="on" small class="ml-4" :disabled="itensFull.length === 0" :dark="!(itensFull.length === 0)">
        <v-icon left>mdi-format-list-numbered</v-icon>
        Separação Automática
        <ListaOpcoes
          :idgrupo="Number(grupo)"
          :filiais_destino="typeof filial === 'string' ? [filial] : filial"
          :tipo_abastecimento="Number(tipoAbastecimento)"
          :status_abastecimento="statusAbastecimento"
          @produtos-separados="ev => $emit('produtos-separados', ev)"
        />
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dark color="#042333">
        <v-btn icon dark @click="fecharDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>
          Separação Automática
          <span class="caption"> - {{ drpReverso ? 'DRP REVERSO' : 'DRP ABASTECIMENTO'}}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="separarProdutos()">
          <v-icon left>mdi-truck-fast</v-icon>
          CONFIRMAR SEPARAÇÃO
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0 mt-3">
        <div class="d-flex">
          <v-col cols="3" class="py-0">
            <auto-complete-filial
              :autoSelecionarTodos="dialog"
              :items="filiais"
              :drpReverso="drpReverso"
              :selecaoMultipla="configuracaoDRP.drp_multipla_selecao_filiais === 'S'"
              @change="filtros.filial = $event"
            ></auto-complete-filial>
          </v-col>

          <v-col cols="3" class="py-0">
            <auto-complete-departamento
              :autoSelecionarTodos="dialog"
              :items="listaDepartamentos"
              @change="filtros.departamentos = $event"
            ></auto-complete-departamento>
          </v-col>

          <v-col cols="3" class="py-0">
            <auto-complete-fornecedor
              :autoSelecionarTodos="dialog"
              :items="listaDeFornecedores"
              :fornecedoresSelecionados="fornecedoresSelecionados"
              @change="filtros.fornecedores = $event"
            ></auto-complete-fornecedor>
          </v-col>

          <v-col cols="3" class="py-0">
            <autoCompleteFrequenciaSaida
              v-model="filtros.frequencias_saidas"
            />
          </v-col>
        </div>
      </v-card-text>

      <dialog-error
        :dialog="dialogError"
        :errors="errorsFiltros"
        @fechar="dialogError = false"
      ></dialog-error>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from '../MixinDRP'
import autoCompleteDepartamento from './autoCompleteDepartamento'
import autoCompleteFornecedor from './autoCompleteFornecedor'
import autoCompleteFilial from './autoCompleteFilial'
import DrpAPI from '../../../../api/drp'
import DialogError from "../../../utils/DialogError";
import ListaOpcoes from "@/components/drp/separacaoDeMercadorias/separacaoAutomatica/ListaOpcoes.vue";
import autoCompleteFrequenciaSaida from "@/components/drp/separacaoDeMercadorias/separacaoAutomatica/autoCompleteFrequenciaSaida.vue";

export default {
  name: "Index.vue",
  mixins: [mixin],
  components: {
    autoCompleteDepartamento,
    autoCompleteFornecedor,
    autoCompleteFilial,
    DialogError,
    ListaOpcoes,
    autoCompleteFrequenciaSaida,
  },
  props: {
    itensFull: {
      type: Array,
      required: false
    },
    filiais: {
      type: Array,
      required: false
    },
    fornecedoresSelecionados: {
      type: Array,
      required: false
    },
    departamentosSelecionados: {
      type: Array,
      required: false
    },
    grupo: {
      type: [Number, String],
      required: false
    },
    filial: {
      type: [Array, String],
      required: false
    },
    tipoAbastecimento: {
      type: [Number, String],
      required: false
    },
    statusAbastecimento: {
      type: [Number, String],
      required: false
    },
    pedido: {
      type: Object,
      required: false
    },
    configuracaoDRP: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    dialog: false,
    dialogError: false,
    filtros: {
      filial: [],
      departamentos: [],
      fornecedores: [],
      frequencias_saidas: [],
    },
    errorsFiltros: []
  }),
  computed: {
    listaDepartamentos () {
      if (this.departamentosSelecionados.length > 0) {
        const idsDepartamentos = this.Helpers
          .arrayColumn(this.departamentosSelecionados, 'id_departamento')

        return this.getDistinctDepartamentos(this.itensFull)
          .filter(item => idsDepartamentos.includes(item.id_departamento))
      }

      return this.getDistinctDepartamentos(this.itensFull)
    },
    listaDeFornecedores () {
      let itens = this.itensFull

      if (this.filtros.departamentos.length > 0) {
        itens = itens.filter(item => this.filtros.departamentos.includes(item.id_departamento))
      }

      if (this.fornecedoresSelecionados.length > 0) {
        const idsFornecedores = this.Helpers
          .arrayColumn(this.fornecedoresSelecionados, 'idfornecedor')

        return this.getDistinctFornecedores(itens)
          .filter(item => idsFornecedores.includes(item.idfornecedor))
      }

      return this.getDistinctFornecedores(itens)
    },
    filtrosValidos () {
      return this.filtros.filial.length > 0 && this.filtros.departamentos.length > 0 && this.filtros.fornecedores.length > 0
    },
    drpReverso () {
      return this.statusAbastecimento === 'DISP DRP'
    }
  },
  methods: {
    fecharDialog () {
      this.dialog = ! this.dialog
    },
    separarProdutos () {
      if (this.filtrosValidos) {
        const headers = this.Helpers.iniciarRequisicao()

        const params = {
          grupo: this.grupo,
          filial: this.filial,
          fornecedores: this.filtros.fornecedores,
          departamentos: this.filtros.departamentos,
          frequencias_saidas: this.filtros.frequencias_saidas,
          estoque_origem: this.filtros.filial,
          tipo: this.tipoAbastecimento,
          idUser: localStorage.getItem("id"),
          status_abastecimento: this.statusAbastecimento,
          pedido: this.pedido.idpedido > 0 ? this.pedido.idpedido : 0
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.separacaoAutomaticaItens(headers, params)
            .then((response) => {
              const {token} = response.data
              localStorage.setItem("token", token)
              this.dialog = false
              this.$emit('separado-automaticamente')
            })
            .catch(() => {
              this.Helpers.logout()
            })
        )
      } else {
        this.setErrosDialog()
        this.dialogError = true
      }
    },
    setErrosDialog () {
      this.errorsFiltros = []

      if (this.filtros.filial.length === 0) {
        this.errorsFiltros.push('Informe o campo Filial')
      }

      if (this.filtros.departamentos.length === 0) {
        this.errorsFiltros.push('Informe o campo Departamento')
      }

      if (this.filtros.fornecedores.length === 0) {
        this.errorsFiltros.push('Informe o campo Fornecedor')
      }
    }
  }
}
</script>

<style scoped>

</style>
